import PageData from '@/modules/app/store/pageData'

export default class PageDataSet {
  [key: string]: PageData
}
